import mod from "-!./APrices.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./APrices.js?vue&type=script&lang=js&external"